import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";

import SplashScreen from "../features/splashScreens/pages/SplashScreen";
import LoginPage from "../features/auth/pages/LoginPage";
import HomePage from "../features/home/pages/HomePage";
import SessionPage from "../features/chat/pages/SessionPage";
import VideoSession from "../features/chat/pages/VideoSession";
import Header from "../shared/components/Header";
import ProfilePage from "../features/profile/pages/ProfilePage";
import HelpPage from "../features/profile/pages/HelpPage";
import ArchivedSessions from "../features/profile/pages/ArchivedSessions";
import "../styles/App.css";

import ReactGA from "react-ga4";
import AuthWrapper from "../shared/utils/AuthWrapper";
import { AuthServices } from "../features/auth/services/AuthServices";
//import OAuthCallback from "../shared/utils/OAuthCallback";
import AnalyticsTracker from "../shared/utils/AnalyticsTracker";

/*
ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);

const GAListener = () => {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
  return null;
};
*/
const MainLayout = ({ children, isActive, setIsActive }) => (
  <>
    <Header isActive={isActive} setIsActive={setIsActive} />
    <main>{children}</main>
  </>
);

function AppContent() {
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();

  const logout = async () => {
    try {
      const response = await AuthServices.logout();
      if (response?.status !== 200) {
        console.warn("Logout failed, continuing anyway");
      }
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      localStorage.clear();
      navigate("/login", { replace: true }); // ✅ clean redirect
    }
  };

  return (
    <>
      <AnalyticsTracker />
      <AuthWrapper logout={logout}>
         <Routes>
          
          <Route path="/" element={<SplashScreen />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/archive" element={<ArchivedSessions />} />

          <Route
            path="/home"
            element={
              <MainLayout isActive={isActive} setIsActive={setIsActive}>
                <HomePage />
              </MainLayout>
            }
          />

          <Route
            path="/session"
            element={
              <MainLayout isActive={isActive} setIsActive={setIsActive}>
                <SessionPage />
              </MainLayout>
            }
          />

          <Route
            path="/vsession"
            element={
              <MainLayout isActive={isActive} setIsActive={setIsActive}>
                <VideoSession />
              </MainLayout>
            }
          />

         
        </Routes>

        

      </AuthWrapper>
    </>
  );
}

function App() {
  return (
    
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
